// Contentful login tags
export const isLoggedInType = (tag) => {
  const tagId = (tag?.sys?.id || "").toLowerCase();
  const loggedInTags = new Set([
    "isuserloggedin",
    // Potential future use
    "isloggedinasessential",
    "isloggedinasdigital",
    "isloggedinaspremium",
  ]);
  return loggedInTags.has(tagId);
};
